import styled from 'styled-components';

export const DropzoneContainer = styled.div<{
  isDragActive: boolean;
  isDragReject: boolean;
  primaryColor: string;
}>`
  background: #f6f6f9;
  border: 2px dashed rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  transition: all 0.2s ease;
  cursor: pointer;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  & span {
    color: ${({primaryColor}) => primaryColor};
    display: block;
  }

  ${(props) => props.isDragActive && `border-color: #00b900;`};
  ${(props) => props.isDragReject && `border-color: red;`};
`;
